<template>
  <div class="superadmin-help-page" data-testid="superadmin-help-page">
    <help-renderer
      audience="superadmin"
      base-path="/admin/help/superadmin"
    />
  </div>
</template>

<script>
/**
 * SuperAdmin help surface -- mounted at `/admin/help/superadmin[/:slug]`
 * inside the SA route group, so it inherits the SA capability guard and the
 * SuperAdminLayout chrome (`docs/user/HELP-SYSTEM-DESIGN.md` decision 4).
 *
 * STAFF DOCUMENTATION, NOT PUBLIC. This is the opposite of the shopper
 * surface: `/help/shopper` is deliberately allowlisted past the auth guard,
 * while this one must stay behind it. The articles describe the platform
 * console -- who the distributors are, what the money figures mean, which
 * capabilities exist -- so the mount point is what keeps it staff-only.
 *
 * Same thin-wrapper shape as OwnerHelpPage and ShopperHelpPage: all behavior
 * lives in the ONE shared HelpRenderer, and the only thing that makes this
 * surface "superadmin help" is the audience it passes and the route group it
 * is mounted in. HelpRenderer already accepted `superadmin` (its validator
 * and its nav headings both list it) and the API already served the audience
 * -- this wrapper and its routes are what was missing.
 */
import HelpRenderer from "@/components/Help/HelpRenderer.vue";

export default {
  name: "SuperAdminHelpPage",
  components: { HelpRenderer },
};
</script>
